import React from 'react';
import styled from 'styled-components';
import { Translate } from '@bynder/localization';
import { token } from '@bynder/design-system';
import { useGuideStore } from '../../stores/guideStore';
import { useIsEntityChanging } from '../../stores/socketsStore';

const GuideSavingStatus: React.FC = () => {
  const activeGuideId = useGuideStore(s => s.activeGuideId);
  const isSaving = useIsEntityChanging(activeGuideId);

  if (isSaving) {
    return (
      <StyledLoadingStatus>
        <Translate id="GUIDE_SAVING_STATUS.SAVING" />
      </StyledLoadingStatus>
    );
  }

  return (
    <StyledSavingStatus>
      <Translate id="GUIDE_SAVING_STATUS.SAVED" />
    </StyledSavingStatus>
  );
};

export const StyledSavingStatus = styled.div`
  font-size: ${token.fontSize75};
`;

const StyledLoadingStatus = styled(StyledSavingStatus)`
  &:after {
    overflow: hidden;
    display: inline-block;
    vertical-align: bottom;
    animation: ellipsis steps(4, end) 900ms infinite;
    content: '\\2026'; /* ascii code for the ellipsis character */
    width: 0;
  }

  @keyframes ellipsis {
    to {
      width: 1.25em;
    }
  }

  @-webkit-keyframes ellipsis {
    to {
      width: 1.25em;
    }
  }
`;

export default GuideSavingStatus;
